import Modal from "./Modal";

export { default as ModalContent } from "./partials/ModalContent";
export { default as ModalDescription } from "./partials/ModalDescription";
export { default as ModalFooter } from "./partials/ModalFooter";
export { default as ModalHeader } from "./partials/ModalHeader";
export { default as ModalTitle } from "./partials/ModalTitle";

export default Modal;
